<app-pokemon-list></app-pokemon-list>
<router-outlet />
